export const color = {
    white :'white',
    black:'black',
    primary:'#bc1f2d',
    gray:'#5b5b5b',
    light_gray:'#ced4da',
    medium_gray:'#afa9ad',
    v_light_gray:'#f5f3f4',
    dark_primary:'#006227',
    inactive_tab:'#FDDFDF',
    profileContainerBg:'#f3f3f3',
    linkHover:'#f7f7f7',
    blue:'#218cc4'
}